var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 4H9C10.1046 4 11 4.89543 11 6V7V9V11.5C11 11.7761 10.7761 12 10.5 12H3C1.89543 12 1 11.1046 1 10V4.5C1 4.22386 1.22386 4 1.5 4ZM12 10V11.5C12 12.3284 11.3284 13 10.5 13H3C1.34315 13 0 11.6569 0 10V4.5C0 3.67157 0.671573 3 1.5 3H9C10.6569 3 12 4.34315 12 6L14.8 3.9C15.2944 3.52918 16 3.88197 16 4.5V11.5C16 12.118 15.2944 12.4708 14.8 12.1L12 10ZM12 8.75L15 11V5L12 7.25V8.75Z",
    fill: "#747487"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOn);
export default __webpack_public_path__ + "static/media/video-on.d58c50f69fc5efeaf5c4d184bdfa4b44.svg";
export { ForwardRef as ReactComponent };